import { AlertColor } from "@mui/material";
import React, { createContext, useState, ReactNode } from "react";

type NotificationContextType = {
  setAlert: React.Dispatch<
    React.SetStateAction<{
      show: boolean;
      message: string;
      variant: AlertColor | undefined | any;
    }>
  >;
  alert: {
    show: boolean;
    message: string;
    variant: AlertColor | undefined;
  };
};

export const NotificationContext = createContext<NotificationContextType>({
  setAlert: () => {},
  alert: {
    show: false,
    message: "",
    variant: undefined,
  },
});

type NotificationContextProviderProps = {
  children: ReactNode;
};

export const NotificationContextProvider = ({
  children,
}: NotificationContextProviderProps) => {
  const [alert, setAlert] = useState({
    show: false,
    message: "",
    variant: undefined,
  });

  React.useEffect(() => {
    if (alert.show) {
      setTimeout(() => {
        setAlert({ show: false, message: "", variant: alert.variant });
      }, 3000);
    }
  }, [alert.show, alert.variant]);

  return (
    <NotificationContext.Provider value={{ alert, setAlert }}>
      {children}
    </NotificationContext.Provider>
  );
};
